import TradingOfferOperationDetail from 'modules/trading/pages/TradingOfferOperationDetail';
import { TradingOfferOperationDetailProvider } from '../pages/TradingOfferOperationDetail/context/TradingOfferOperationDetailContext';

const TradingOfferOperationDetailContainer = () => (
  <TradingOfferOperationDetailProvider>
    <TradingOfferOperationDetail />
  </TradingOfferOperationDetailProvider>
);

export default TradingOfferOperationDetailContainer;
